'use client'

import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { useSignUpGuestStore } from '@/features/sign-up'
import { TTermsForm } from '@/features/sign-up'
import { SignUpTerms } from '@/widgets/sign-up'

export const SignUpGuestTerms = () => {
  const router = useRouter()
  const actions = useSignUpGuestStore(state => state.actions)
  const terms = useSignUpGuestStore(state => state.terms)

  const handleFormFieldChange = useCallback(
    (formValues: TTermsForm) => {
      actions.updateTerms(formValues)
    },
    [actions],
  )

  const handleSubmit = () => {
    router.push(`/sign-up/guest?step=info`)
  }

  return (
    <SignUpTerms
      onSubmit={handleSubmit}
      defaultValues={terms}
      onFormFieldChange={handleFormFieldChange}
    />
  )
}
